module.exports = __webpack_public_path__ + "img/yqhy.5bf015a0.png";